import api from "../../utils/apiUserTienda";

export const getDireccionesByCliente = async (clienteId) => {
  const res = await api.get(`/api/tienda/clientes_direccion/obtener/${clienteId}`);
  return res.data;
};

export const crearDireccion = async (data) => {
  const res = await api.post("/api/tienda/clientes_direccion/crear", data);
  return res.data;
};

export const actualizarDireccion = async (id, data) => {
  const res = await api.put(`/api/tienda/clientes_direccion/actualizar/${id}`, data);
  return res.data;
};
